module.exports = __webpack_public_path__ + "static/media/primabuild.1a2342db.png";